// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagDeficiencyModel extends SmartTagModel {
	deficiencyType?: any[];
	deficiencySeverity?: boolean;

	constructor() {
		super();
		this.deficiencyType	 = [];
		this.deficiencySeverity = false;
	}
}

export class SmartTagDeficiency extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagDeficiencyModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagDeficiencyModel): void{
		const title = data.title || data.subCategory || '';
		const deficiencyType = data.deficiencyType || [];
		const deficiencySeverity = data.deficiencySeverity || null;
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (deficiencyType && deficiencyType.length > 0) {
			this.addText(`<span title="Deficiency Type:">Deficiency Type:</span>`);
			deficiencyType.forEach((deficiency: any) => {
				this.addText(`<span title="${deficiency.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${deficiency.typeName}</span>`);
			});
		}

		if (deficiencySeverity !== null) {
			this.addText(`<span title="Compromises livability?"> <i class=" ${deficiencySeverity ? 'fa fa-check-square' : 'fa-square far'}"></i> Compromises livability? </span>`);
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
